import * as React from 'react';

const MenuThreeDotsIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={2} height={14}>
    <path
      fill={fillColor}
      d="M.997 13.667a.956.956 0 0 1-.705-.295.97.97 0 0 1-.292-.708c0-.276.098-.511.295-.706a.97.97 0 0 1 .708-.291c.276 0 .51.098.705.294A.97.97 0 0 1 2 12.67c0 .275-.098.51-.295.705a.97.97 0 0 1-.708.292ZM.997 8a.956.956 0 0 1-.705-.295A.97.97 0 0 1 0 6.997c0-.276.098-.51.295-.705A.97.97 0 0 1 1.003 6c.276 0 .51.098.705.295A.97.97 0 0 1 2 7.003c0 .276-.098.51-.295.705A.97.97 0 0 1 .997 8Zm0-5.667a.956.956 0 0 1-.705-.294A.97.97 0 0 1 0 1.33C0 1.055.098.82.295.625a.97.97 0 0 1 .708-.292c.276 0 .51.099.705.295A.97.97 0 0 1 2 1.336c0 .276-.098.511-.295.706a.97.97 0 0 1-.708.291Z"
    />
  </svg>
);

export default MenuThreeDotsIcon;
